import { FormControl } from '@angular/forms';
import {
  BaseNewRequestControlName,
  InvestorDetailsNewRequestFormGroup,
} from '../../../../shared/base-new-request-form/base-new-request-form.model';

export enum HSTNNewRequestAdditionalControlName {
  ActivityDescription = 'activityDescription',
  InstallationOperatingTime = 'installationOperatingTime',
  EmissionTypeAndAmount = 'emissionTypeAndAmount',
  EmissionReductionMethods = 'emissionReductionMethods',
  ReductionCompliantDescription = 'reductionCompliantDescription',
}

export const HSTNNewRequestControlName = {
  ...BaseNewRequestControlName,
  ...HSTNNewRequestAdditionalControlName,
};

export interface HSTNNewRequestFormGroup
  extends InvestorDetailsNewRequestFormGroup {
  [HSTNNewRequestControlName.ActivityDescription]: FormControl<string>;
  [HSTNNewRequestControlName.InstallationOperatingTime]: FormControl<string>;
  [HSTNNewRequestControlName.EmissionTypeAndAmount]: FormControl<string>;
  [HSTNNewRequestControlName.EmissionReductionMethods]: FormControl<string>;
  [HSTNNewRequestControlName.ReductionCompliantDescription]: FormControl<string>;
}
